import * as React from "react";
import { SVGProps } from "react";

const Fusion = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 218 218" {...props}>
    <path
      fill="#1e9ada"
      fillRule="evenodd"
      d="M109.22 0A109.22 109.22 0 1 1 0 109.22 109.22 109.22 0 0 1 109.22 0Z"
    />
    <path
      fill="#fefefe"
      d="M84.84 61c-27.09 41.55-43.73 99.25-50.22 118.85-3.65-37 15.62-87.36 29.73-117.13-6.49.3-41.09 2.74-60.26 22.55 0 0 10.35-31.8 70.11-41.45l.2-.41c46.77-68.37 81.87-27.53 81.87-27.53-21.31-3.56-39.87 7.11-55.7 24.48 7.71-.3 57.63-.91 72 38.6 0 0-28.92-20.72-87.76-18Zm33.79 47.64a21.74 21.74 0 1 0 21.71 21.74 21.69 21.69 0 0 0-21.71-21.74Z"
    />
  </svg>
);

export default Fusion;
